webpackJsonp([35783957827783],{

/***/ 107:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { style: { margin: '3rem auto', maxWidth: 960 } },
	    children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: pull from Github, feed as GraphQL data layer
	var openSource = [{
	  project: {
	    title: 'React Material UI',
	    link: 'https://github.com/mui-org/material-ui'
	  },
	  contributions: [{
	    title: '[codemod] Update import paths for colors v1',
	    link: 'https://github.com/mui-org/material-ui/pull/8311'
	  }, {
	    title: '[codemod] Update import paths for svg-icons v1',
	    link: 'https://github.com/mui-org/material-ui/pull/8333'
	  }]
	}];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    openSource.map(function (_ref) {
	      var project = _ref.project,
	          contributions = _ref.contributions;
	      return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: project.link, target: '_blank' },
	          project.title
	        ),
	        _react2.default.createElement(
	          'ul',
	          { style: { paddingTop: 10 } },
	          contributions.map(function (c) {
	            return _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: c.link, target: '_blank' },
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  c.title
	                )
	              )
	            );
	          })
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(104);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(83);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _openSource = __webpack_require__(233);
	
	var _openSource2 = _interopRequireDefault(_openSource);
	
	var _socialGuns = __webpack_require__(238);
	
	var _socialGuns2 = _interopRequireDefault(_socialGuns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import styles from './index.module.scss';
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Vividh Chandna'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Hi! I am a Software Developer passionate for technology, the web, video games and everything that overlaps. I embrace the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://hackernoon.com/how-it-feels-to-learn-javascript-in-2016-d3a717dd577f', target: '_blank' },
	        'JS fatigue'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Currently developing internal products & payments at Furlenco. Past FusionCharts.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I like to build creative interfaces with a focus on usability. I also have full-stack exposure through my experience of working with technologies such as NodeJS and Ruby on Rails.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { style: { color: '#ababab' } },
	      'Current Location: Bangalore, India'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gridTemplateRows: 40 } },
	      _react2.default.createElement(
	        'span',
	        { style: { gridColumnStart: 1, justifySelf: 'center', alignSelf: 'center' } },
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:vividhchandna@gmail.com', target: '_blank' },
	          'Email'
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { gridColumnStart: 2, justifySelf: 'center', alignSelf: 'center' } },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/vividh', target: '_blank' },
	          'Github'
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { gridColumnStart: 3, justifySelf: 'center', alignSelf: 'center' } },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://twitter.com/vividhC', target: '_blank' },
	          'Twitter'
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { gridColumnStart: 4, justifySelf: 'center', alignSelf: 'center' } },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.linkedin.com/in/vividh-chandna-a99a3040/', target: '_blank' },
	          'LinkedIn'
	        )
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Open Source'
	      ),
	      _react2.default.createElement(_openSource2.default, null)
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	// import profile from '../assets/profile.jpg';
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = [{ title: 'twitter', icon: 'twitter-icon', link: 'https://twitter.com/vividhC' }];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-493557faf51b6aa43ab2.js